/** Shown when there is no planning yet: onboarding for admins, an explanation for everyone else. */
import { FileUp, Hourglass } from 'lucide-react';
import { Link } from 'react-router';
import { hasRole, useMe } from '../lib/session.js';
import { buttonClass } from './Button.js';
import { EmptyState } from './States.js';

export function NoPlanning() {
  const me = useMe();
  if (hasRole(me, 'admin')) {
    return (
      <EmptyState
        icon={<FileUp />}
        title="Importeer je ProjectLibre-bestand"
        action={
          <Link to="/beheer/import" className={buttonClass('primary', 'lg')}>
            Naar importeren
          </Link>
        }
      >
        Er is nog geen planning. Upload het huidige ProjectLibre-bestand (.pod of .xml) via Beheer → Import/Export. Daarna kun je de
        planning hier bekijken en bewerken, en blijft exporteren naar ProjectLibre altijd mogelijk.
      </EmptyState>
    );
  }
  return (
    <EmptyState icon={<Hourglass />} title="Nog geen planning beschikbaar">
      De beheerder heeft de planning nog niet in TransectLibre gezet. Zodra dat gebeurd is, verschijnt hij hier vanzelf.
    </EmptyState>
  );
}
